import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';
import moment from "moment-timezone";
import { setRoomStatus, getRoomDetails } from "../../api/instaDocBFFApi";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import ErrorPage from "../common/ErrorPage";
import YesNoModal from "../common/YesNoComponent";
import TwilioVideo from "./videoVisitV2/";
import { PROVIDER } from './videoVisitV2/constants';
import AmbulatoryCareRoomStatus from "../care/AmbulatoryCareRoomStatus";
import Header from "../header/Header";
import { endCall, getCallDuration } from "./videoVisitV2/utils";
import enhanceMessage from './VideoVisitV2/components/enhanceMessage';
import Spinner from "../common/spinner";
import Text from '../common/input/text';
import * as Formatting from "./../../helpers/formatting";
import VideoVisitToast from "./VideoVisitToast";
import Preflight from './videoVisitV2/components/Preflight';
import { logRTCDiagnostics } from "./videoVisitV2/utils/RTCDiagnostics";
import * as limbo from "../../api/limboApi";
import VisitHistory from './VisitHistory';

class AmbulatoryCareVideoVisit extends React.Component {
    constructor(props) {
        super(props);

        this.currentBrowserName = Tools.browserDetection();

        const twilioOptions = this.currentBrowserName === 'Firefox' ? props.twilioSettingsForFireFox : props.twilioSettings;

        this.state = {
            timeToStart: false,
            activeVideoId: { id: "", url: "" },
            testVideoOpen: false,
            videoVisitError: false,
            videoVisitOpen: false,
            csnIdOfAppointment: this.props.match.params.csnId,       // CSN ID of the visit, from the route.
            hasAudioIn: false,
            hasAudioOut: false,
            hasVideoIn: false,
            hardwareScanned: false,
            isFetchingTwilioToken: false,
            twilioUserName: null,
            showSpinner: false,
            twilioOptionsForTestRoom: twilioOptions ? twilioOptions.unescapeHTML() : null,
            showLeaveVisitModal: false,
            twilioTestRoomSettingsSelected: false,
            twilioDiagnosticsSettings: null,
            showPreflight: false,
            isConnecting: false,
            rtcDiagnosticsComplete: false,
            preflightComplete: false,
            roomTokenAssigned: false
        };

        this.getAudioVideoStatus = this.getAudioVideoStatus.bind(this);
        this.getAppointmentDetails = this.getAppointmentDetails.bind(this);
        this.isTimeToStart = this.isTimeToStart.bind(this);
        this.startVideoVisit = this.startVideoVisit.bind(this);
        this.testVideoVisit = this.testVideoVisit.bind(this);
        this.leaveVideoVisit = this.leaveVideoVisit.bind(this);
        this.closeRoom = this.closeRoom.bind(this);
        this.onLeaveVisitYesClick = this.onLeaveVisitYesClick.bind(this);
        this.onLeaveVisitNoClick = this.onLeaveVisitNoClick.bind(this);

        this.videoErrorMsg = "";
        let prevTimeToStart = false;

        // set a timer to enable the launch button when it's time for the visit to start, and disable it when the visit has expired.
        this.timer = setInterval(() => {
            const appDetails = this.getAppointmentDetails();
            const timeToStart = appDetails && appDetails.timeToStart ? true : false;
            if (timeToStart !== prevTimeToStart) {
                prevTimeToStart = timeToStart;
                this.setState({});
            }
        }, 30000);

        this.logEnterRoomBtnIsDisabled = null;
        this.logEnterRoomBtnForRoomId = null;
        this.logEnterRoomBtnForTimeToStart = null;
        this.logEnterRoomBtnForToken = null;
        //  this.logEnterRoomBtnForHdMissing = null;
        // this.logEnterRoomBtnForErrorMsg = null;
        this.isOnFlyVisit = false;
        this.isOnFlyVisitStarted = false;
    }

    componentDidMount() {
        logUI("UI.VideoVisit.ComponentDidMount", new Date(), Tools.getURLPath(), null, this.state.csnIdOfAppointment);
    }

    componentWillUnmount() {
        window.twilioRoom = null;
        logUI("UI.VideoVisit.ComponentWillUnmount", new Date(), Tools.getURLPath(), null, this.state.csnIdOfAppointment);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.csnId !== prevProps.match.params.csnId) {
            this.setState({ csnIdOfAppointment: this.props.match.params.csnId });
        }
    }

    handleSettingsChange = (e) => {
        if (e) {
            const target = e.target;
            this.setState({
                twilioOptionsForTestRoom: target.value
            });
        }
    }

    // search ambulatory and urgent care video visits for a visit that matches the route parameter.
    getAppointmentDetails() {
        const { instaDocToken, providerAppointments, sameDayCareAppointments, delayReadingPatientInRoomTimeSecs } = this.props;
        var csnIdOfAppointment = Formatting.getCsnId(this.props.location.pathname);
        var ret = null;
        let videoVisits = [];
        if (providerAppointments) {
            videoVisits = videoVisits.concat(providerAppointments);
        }
        if (sameDayCareAppointments) {
            videoVisits = videoVisits.concat(sameDayCareAppointments);
        }

        ret = videoVisits.find(visit => visit.csnId === csnIdOfAppointment);
        if (ret && ret.patientInRoom && !this.patientInRoomEnterTime) { // Patient Enters the Room and getRoomDetails API is not called yet.
            this.patientInRoomEnterTime = true;
            this.timeout(delayReadingPatientInRoomTimeSecs * 1000).then(() => { //wait for configurable time, then call getRoomDetails API.
                getRoomDetails(instaDocToken, csnIdOfAppointment)
                    .then(resp => {
                        logUI("UI.VideoVisit.GetRoomDetails", new Date(), Tools.getURLPath(), resp, csnIdOfAppointment);
                        const callStartDateTime = resp && resp.epicAppointmentDetails && resp.epicAppointmentDetails.inProgressStartTimeUtc ? resp.epicAppointmentDetails.inProgressStartTimeUtc : "";

                        if (callStartDateTime) {
                            try {
                                const date = new Date(callStartDateTime);
                                window.patientInRoomEnterTime = date.getTime();
                            }
                            catch (err) {
                                window.patientInRoomEnterTime = null;
                            }
                        }
                    })
                    .catch(err => {
                        logUI("UI.VideoVisit.GetRoomDetails.Error", new Date(), Tools.getURLPath(), err, csnIdOfAppointment);
                        window.patientInRoomEnterTime = null;
                    })
            });
        }


        if (ret) {
            ret.timeToStart = this.isTimeToStart(ret);
        }

        return ret;
    }

    timeout(ms) { // Promisifying setTimeout as we need to wait for ms before firing our API.
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    getAudioVideoStatus(csnId) {
        var hasAudioIn = false;
        var hasAudioOut = false;
        var hasVideoIn = false;

        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices()
                .then(info => {
                    for (var i = 0; i < info.length; i++) {
                        const device = info[i];
                        const deviceType = device.kind;

                        if (deviceType.toLowerCase() === "audioinput") {
                            hasAudioIn = true;
                        }

                        if (deviceType.toLowerCase() === "audiooutput") {
                            hasAudioOut = true;
                        }

                        if (deviceType.toLowerCase() === "videoinput") {
                            hasVideoIn = true;
                        }
                    }
                    //Audio out validation is not supported by iOS.
                    if ((Tools.isSafari() || Tools.isIos() || this.currentBrowserName === 'Firefox') && !hasAudioOut) {
                        logUI("UI.VideoVisit.HardwareScan.AudioOut.Skip", new Date(), Tools.getURLPath(), null, csnId);
                        hasAudioOut = true;
                    }

                    // some loser needs to get in the visit even though he has no camera  :)
                    if (window.location.search && window.location.search.toLocaleLowerCase().indexOf("hwbypass") > 0) {
                        hasAudioIn = true;
                        hasAudioOut = true;
                        hasVideoIn = true;
                    }

                    //Try to enable audio/video device.
                    if (hasAudioIn || hasVideoIn) {
                        this.enableAudioAndVideo(hasAudioIn, hasVideoIn, csnId);
                    }

                    this.setState({ hasAudioIn: hasAudioIn, hasAudioOut: hasAudioOut, hasVideoIn: hasVideoIn, hardwareScanned: true });
                    logUI("UI.VideoVisit.GetAudioVideoStatus", new Date(), Tools.getURLPath(), null, csnId);
                })
                .catch(err => {
                    this.setState({ hardwareScanned: false });
                    console.log("Error detecting client audio/video hardware");
                    logUI("UI.VideoVisit.GetAudioVideoStatus.Error", new Date(), Tools.getURLPath(), null, csnId);
                });
        }
    }

    //Try to enable audio and video
    enableAudioAndVideo(audio, video, csnId) {
        try {
            const constraint = {}
            if (audio)
                constraint.audio = true;
            if (video)
                constraint.video = true;

            // Older browsers might not implement mediaDevices at all, so we set an empty object first
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }
            // Some browsers partially implement mediaDevices.
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                    }
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            }
            navigator.mediaDevices.getUserMedia(constraint)
                .then(function (stream) {
                    if (!stream) { return; }

                    console.log(stream);

                    const tracks = stream.getTracks();
                    if (!tracks) { return; }
                    tracks.forEach(track => track.stop());
                })
                .catch(function (err) {
                    console.log(err.name + ": " + err.message);
                    logUI("UI.VideoVisit.EnableAudioOrVideo.Error", new Date(), Tools.getURLPath(), { error: err }, csnId);
                    //NotAllowedError - "User has denied accessed"
                    //PermissionDismissedError                   
                });
        } catch (e) {
            console.log(e);
            logUI("UI.VideoVisit.EnableAudioOrVideo.Exception", new Date(), Tools.getURLPath(), { error: e }, csnId);
        }
    }

    isTimeToStart(appointmentDetails) {
        let ret = false;
        if (appointmentDetails) {
            const now = new Date();
            const { minutesBefore, minutesAfter } = this.props;
            let startTime = new Date(appointmentDetails.apptDateTime + ' CST'); // apptDateTime is supposed to be in cst
            if (startTime.toString() === 'Invalid Date') { // time zone was already in apptDateTime
                startTime = new Date(appointmentDetails.apptDateTime);
            }

            var beforeDate = moment(startTime).add(-1 * minutesBefore, 'minutes');
            var afterDate = moment(startTime).add(appointmentDetails.duration, 'minutes').add(minutesAfter, 'minutes');

            var dNow = moment(now);
            if (dNow._d >= beforeDate._d && dNow._d <= afterDate._d) {
                ret = true;
            }
        }
        return ret;
    }

    startVideoVisit(appointmentDetails) {
        const csnId = Formatting.getCsnId(this.props.location.pathname);
        if (this.state.errorMessage)
            this.setState({ errorMessage: null });
        this.getAudioVideoStatus(csnId);
        if (this.isOnFlyVisit) {
            this.isOnFlyVisitStarted = true;
            if (appointmentDetails && appointmentDetails.csnId) {
                this.props.getShareLinkHistory(appointmentDetails.csnId);
            }
            logUI("UI.VideoVisit.OnFlyVisit.Started", new Date(), Tools.getURLPath(), null, csnId);
        } else {
            logUI("UI.VideoVisit.EnterRoom.Clicked", new Date(), Tools.getURLPath(), null, csnId);
        }
        if (this.getProviderInAnotherRoom()) {
            if (!this.state.showLeaveVisitModal) {
                this.setState({ showLeaveVisitModal: true });
            }
        } else {
            if (appointmentDetails && appointmentDetails.timeToStart) {
                this.setState({ showLeaveVisitModal: false });
                this.doVideoVisit(csnId);//this.state.csnIdOfAppointment);
            }
        }
    }

    // same as startVideoVisit, but only used if the user is in the Video_POC role, and only uses the test MYBSWHEALTHLOBBY chat room.
    testVideoVisit() {
        const roomId = "e31214186e0b42d8aa8d51046a44e064";
        this.getAudioVideoStatus();
        logUI("UI.VideoVisit.EnterTestRoom.Clicked", new Date(), Tools.getURLPath(), null, roomId);
        var isPOC = true;
        if (this.getProviderInAnotherRoom()) {
            if (!this.state.showLeaveVisitModal) {
                this.setState({ showLeaveVisitModal: true });
            }
        } else {
            this.setState({ showSpinner: true, testVideoOpen: true, showLeaveVisitModal: false, roomTokenAssigned: false, preflightComplete: false, rtcDiagnosticsComplete: false }, () => {
                if (isPOC === true) {
                    this.doVideoVisit(roomId);
                }
            });
        }
    }

    doVideoVisit(roomId) {
        this.patientInRoomEnterTime = false;
        const sdcProviderId = this.props.sameDayCareProviderId ? this.props.sameDayCareProviderId : "";
        const isSameDayCare = this.props.match.params.sameDayCare;
        const participantEpicId = isSameDayCare && sdcProviderId !== "" ? sdcProviderId : this.props.epicId || this.props.lanId;
        const participantName = this.props.providerExternalName ? Formatting.titleCase(this.props.providerExternalName) : this.props.displayName ? this.props.displayName : "";
        this.setState({ showSpinner: true, isFetchingTwilioToken: true, roomTokenAssigned: false, preflightComplete: false, rtcDiagnosticsComplete: false });
        this.props.getProviderToken(participantEpicId, participantName, roomId, this.callbackForProviderToken, 2);
        window.scrollTo(0, 0);
    }

    callbackForProviderToken = (resp, err) => {
        if (resp) {
            if (!resp.jwtToken) {
                throw "JWT Token is null";
            }

            //this.setState({ videoVisitOpen: true });

            var token = resp.jwtToken;
            var roomName = resp.room;

            let twilioUserName = resp && resp.username ? resp.username : null;
            const twilioConnectSettings = resp && resp.twilioConnectSettings ? resp.twilioConnectSettings : null;
            const twilioDiagnosticsSettings = resp && resp.twilioDiagnosticsSettings ? resp.twilioDiagnosticsSettings : null;
            if (!twilioConnectSettings) {
                logUI("UI.VideoVisit.DynamicSettings.NotFound", new Date(), Tools.getURLPath(), null, roomName);
            } else {
                logUI("UI.VideoVisit.DynamicSettings.Found", new Date(), Tools.getURLPath(), twilioConnectSettings, roomName);
            }
            const { enablePreflightTest = false, preflightDurationInSeconds = 5 } = twilioDiagnosticsSettings || {};
            const { enableRTCDiagnostics, enableTwilioPreflightTest } = window.serverData.data;
            this.setState({ roomConnectionData: { token, roomName, twilioUserName, twilioConnectSettings, twilioDiagnosticsSettings } }, () => {
                if (!enablePreflightTest || !enableTwilioPreflightTest) {
                    this.onPreflightComplete();
                } else {
                    this.setState({ showPreflight: true, preflightTokenInfo: { token, roomName, twilioUserName, testDuration: preflightDurationInSeconds } });
                }
            });
            if (!enableRTCDiagnostics) {
                this.onRTCDiagnosticsComplete();
            }
            else {
                logRTCDiagnostics(twilioDiagnosticsSettings, roomName, twilioUserName, this.onRTCDiagnosticsComplete);
            }
        }
        else {
            this.setState({ videoVisitError: true, showSpinner: false, testVideoOpen: false });
            console.log("video visit error", err);
            logUI("UI.VideoVisit.Loaded.Error", new Date(), Tools.getURLPath(), roomName);
        }
    }

    kickoutGuest = (participantId) => {
        const { roomConnectionData } = this.state;
        if (!roomConnectionData || !roomConnectionData.roomName || !participantId) return;
        const url = Tools.buildUrl(window.serverData.data.portalAPIURL, `/api/v2/video/kickout?roomid=${roomConnectionData.roomName}`);
        const body = {
            participantId: participantId
        };
        const params = {
            headers: {
                "accept": "application/json",
                "content-type": "application/json"
            },
            body: JSON.stringify(body),
            method: 'POST'

        };
        logUI("UI.VideoVisit.KickoutGuest.Clicked", new Date(), Tools.getURLPath(), { roomid: roomConnectionData.roomName, participantId }, roomConnectionData.roomName);
        fetch(url, params)
            .then(resp => {
                return resp.json();
            })
            .then(response => {
                const csnIdOfAppointment = Formatting.getCsnId(this.props.location.pathname);
                this.props.getShareLinkHistory(csnIdOfAppointment);
                logUI(`UI.VideoVisit.KickoutGuest.Clicked.Success`, new Date(), Tools.getURLPath(), { roomid: roomConnectionData.roomName, participantId }, roomConnectionData.roomName);
            }
            )
            .catch(error => {
                logUI("UI.VideoVisit.KickoutGuest.Clicked.Failure", new Date(), Tools.getURLPath(), { roomid: roomConnectionData.roomName, participantId }, roomConnectionData.roomName);
            })
    }

    onTwilioRoomConnected = (room) => {
        limbo.videoVisitRoomStatus(this.props.instaDocToken, this.state.roomName, true);  // required to get room status updates via signal-r
        this.twilioRoom = room;
        this.setState({ videoVisitError: false, errorMessage: null, showSpinner: false });
        this.setActiveVideoId();
        if (!this.getIsTestLobby()) {
            this.updateStatus(this.getAppointmentDetails(), true);
        }
    }

    onTwilioRoomError = (error) => {
        const { message, code, name } = error || {};
        if (endCall) {
            endCall();
        }

        let errorCode = '';
        const mediaErrors = [
            'NotAllowedError',
            'NotFoundError',
            'NotReadableError',
            'OverconstrainedError'
        ];

        if (name && mediaErrors.indexOf(name) > -1) {
            errorCode = name;
        } else if (code) {
            errorCode = code;
        }

        const currentBrowserIsMobile = Tools.isMobile();

        const roomError = enhanceMessage(message, errorCode, currentBrowserIsMobile, PROVIDER);
        if (roomError)
            this.setState({ errorMessage: roomError, showSpinner: false });
    }

    setActiveVideoId() {
        const activeVideoUrl = "/providervideovisit/" + (this.props.match.params.csnId ? this.props.match.params.csnId + "/" : "") + (this.props.match.params.sameDayCare ? "samedaycare" : "");
        this.setState({ activeVideoId: { id: this.props.match.params.csnId ? this.props.match.params.csnId : "", url: activeVideoUrl } });
    }

    closeRoom(appointmentDetails) {
        let activityJsonForCloseRoom = null;
        const csnId = Formatting.getCsnId(this.props.location.pathname)
        if (appointmentDetails) {
            activityJsonForCloseRoom = {
                roomId: appointmentDetails.csnId, csnId: appointmentDetails.epicApptCSNId,
                apptDate: Tools.dateStringFormat(appointmentDetails.apptDateTime),
                apptTime: appointmentDetails.apptTime,
                apptStatus: appointmentDetails.status ? appointmentDetails.status : ""
            };
        }
        setRoomStatus(this.props.instaDocToken, csnId/*this.state.csnIdOfAppointment*/, "ROOM_CLOSE")
            .then(resp => {
                if (this.state.videoVisitOpen === true) {
                    this.leaveVideoVisit(appointmentDetails);
                }

                this.updateStatus(appointmentDetails, false);
                logUI("UI.VideoVisit.CloseRoom", new Date(), Tools.getURLPath(), activityJsonForCloseRoom, csnId);
            })
            .catch(err => {
                logUI("UI.VideoVisit.CloseRoom.Error", new Date(), Tools.getURLPath(), activityJsonForCloseRoom, csnId);
            });
    }

    leaveVideoVisit = (appointmentDetails) => {
        this.setState({ showSpinner: true });
        const csnIdOfAppointment = Formatting.getCsnId(this.props.location.pathname);
        logUI("UI.VideoVisit.LeaveRoom.Clicked", new Date(), Tools.getURLPath(), null, csnIdOfAppointment);
        limbo.videoVisitRoomStatus(this.props.instaDocToken, csnIdOfAppointment, false);
        if (endCall) {
            endCall();
        }

        this.props.getShareLinkHistory(csnIdOfAppointment);

        if (window.patientInRoomEnterTime) {
            const callDuration = getCallDuration(window.patientInRoomEnterTime);
            logUI("UI.VideoVisit.CallDuration", new Date(), Tools.getURLPath(), { callDuration: callDuration, roomId: csnIdOfAppointment }, csnIdOfAppointment);
            window.patientInRoomEnterTime = null;
        }
        this.setState({ videoVisitOpen: false, testVideoOpen: false, token: null, showSpinner: false, activeVideoId: { id: "", url: "" }, errorMessage: null }, () => {
            if (this.state.showLeaveVisitModal) {
                if (this.getIsTestLobby()) {
                    this.testVideoVisit();
                } else {
                    this.startVideoVisit(appointmentDetails);
                }
            }
        });
    }

    completeVideoVisit = () => {
        const { twilioUserName } = this.state;
        const displayName = this.props.providerExternalName ? Formatting.titleCase(this.props.providerExternalName) : this.props.displayName ? this.props.displayName : "";
        logUI("UI.VideoVisit.CompleteVisit.Clicked", new Date(), Tools.getURLPath(), null, Formatting.getCsnId(this.props.location.pathname));
        if (!twilioUserName) {
            const participantEpicId = this.props.match.params.sameDayCare && this.props.sameDayCareProviderId ? this.props.sameDayCareProviderId : this.props.epicId;
            let tUserName = participantEpicId && displayName && this.props.employeeRole ? "External||" + participantEpicId + "||" + this.props.employeeRole.toLowerCase() === 'staff' ? 'Staff' : 'Provider' + "||" + displayName : "";
            this.setState({ showModal: true, twilioUserName: tUserName })
        } else {
            this.setState({ showModal: true })
        }
    }

    getVideoErrorMsg(hardwareError) {
        let errorMsg = '';

        if (hardwareError) {
            var missingHardware = [];
            if (!this.state.hasAudioIn) {
                if (this.props.userName !== "e87263@bswhealth.org") {
                    missingHardware.push("a microphone");
                }
            }

            if (!this.state.hasAudioOut) {
                if (this.props.userName !== "e87263@bswhealth.org") {
                    missingHardware.push("speakers");
                }
            }

            if (!this.state.hasVideoIn) {
                if (this.props.userName !== "e87263@bswhealth.org") {
                    missingHardware.push("a video camera");
                }
            }

            var hardwareString = missingHardware.join(", ");
            var lastComma = hardwareString.lastIndexOf(",");
            if (lastComma > 0) {
                hardwareString = hardwareString.substring(0, lastComma) + " and " + hardwareString.substring(lastComma + 1, hardwareString.length);
            }
            errorMsg = "We're not able to load your video visit. Please make sure you have " + hardwareString + " connected and enabled on your computer.";
        }

        return errorMsg;
    }

    getProviderInAnotherRoom(isSDCVisit) {
        const { activeVideoId } = this.state;
        if ((activeVideoId.id !== "") && (activeVideoId.id !== this.props.match.params.csnId)) {
            return true;
        }
        return false;

        //if (isSDCVisit) return false;
        //const { csnIdOfAppointment } = this.state;
        //const { providerAppointments } = this.props;
        //const appointments = providerAppointments;
        //if (appointments) {
        //    for (let i = 0; i < appointments.length; i++) {
        //        if (csnIdOfAppointment !== appointments[i].csnId && appointments[i].providerInRoom) {
        //            return true;
        //        }
        //    }
        //}
        //return false;
    }

    getPatientName = () => {
        const { providerAppointments, sameDayCareAppointments } = this.props;
        const { activeVideoId } = this.state;
        const activeCsnId = activeVideoId && activeVideoId.id ? activeVideoId.id : '';
        let appointments = [];
        if (providerAppointments) {
            appointments = appointments.concat(providerAppointments);
        }
        if (sameDayCareAppointments) {
            appointments = appointments.concat(sameDayCareAppointments);
        }
        let activeAppointment = appointments && appointments.length > 0 ? appointments.filter(item => item && item.csnId && item.csnId === activeCsnId) : [];
        return activeAppointment && activeAppointment.length > 0 ? activeAppointment[0].patientName : "";
    }

    updateStatus(appointment, staffOrProviderInRoom) {
        if (this.props.employeeRole && this.props.employeeRole.toLowerCase() === 'staff') {
            appointment.epicAppointmentDetails.staffInRoom = staffOrProviderInRoom;
        }
        else {
            appointment.epicAppointmentDetails.providerInRoom = staffOrProviderInRoom;
        }
        this.props.refreshRooms(appointment);
    }

    onTwilioEndCall = (room) => {
        console.log("Room disconnected");
        logUI("UI.VideoVisit.LeftRoom", new Date(), Tools.getURLPath(), JSON.stringify({ "VideoType": "Twilio" }), room);
        if (!this.getIsTestLobby()) {
            this.updateStatus(this.getAppointmentDetails(), false);
        }
        //setTimeout(() => this.props.refreshRooms(), 1000);
    }

    onLeaveVisitYesClick(appointmentDetails) {
        logUI("UI.VideoVisit.ConfirmationModal.LeaveVisit.Yes.Clicked", new Date(), Tools.getURLPath(), null, appointmentDetails.csnId);
        this.leaveVideoVisit(appointmentDetails);
    }

    onLeaveVisitNoClick() {
        logUI("UI.VideoVisit.ConfirmationModal.LeaveVisit.No.Clicked", new Date(), Tools.getURLPath(), null, Formatting.getCsnId(this.props.location.pathname));
        this.setState({ showLeaveVisitModal: false });
    }

    getIsTestLobby() {
        return this.props.match.params.csnId ? this.props.match.params.csnId.toLowerCase() === "lobby" : false;
    }

    onPreflightComplete = () => {
        this.setState({ preflightComplete: true }, () => {
            const { roomConnectionData, rtcDiagnosticsComplete, roomTokenAssigned } = this.state;
            const { token = "", roomName = "", twilioUserName = "", twilioConnectSettings = {}, twilioDiagnosticsSettings = {} } = roomConnectionData || {};
            if (rtcDiagnosticsComplete && !roomTokenAssigned && token && roomName) {  // restoring room state once preflight and rtcDiagnostics both done either with success or failure.
                this.setState({
                    token,
                    roomName,
                    twilioUserName: twilioUserName,
                    twilioConnectSettings: twilioConnectSettings,
                    twilioDiagnosticsSettings: twilioDiagnosticsSettings,
                    showPreflight: false,
                    isFetchingTwilioToken: false,
                    roomTokenAssigned: true,
                    videoVisitOpen: this.videoErrorMsg ? false : true
                });
            }
            else
                this.setState({ showPreflight: false });
        });
    }


    onRTCDiagnosticsComplete = () => {
        this.setState({ rtcDiagnosticsComplete: true }, () => {
            const { roomConnectionData, preflightComplete, roomTokenAssigned } = this.state;
            const { token = "", roomName = "", twilioUserName = "", twilioConnectSettings = {}, twilioDiagnosticsSettings = {} } = roomConnectionData || {};
            if (preflightComplete && !roomTokenAssigned && token && roomName) { // restoring room state once  preflight and rtcDiagnostics both done either with success or failure.
                this.setState({
                    token,
                    roomName,
                    twilioUserName: twilioUserName,
                    twilioConnectSettings: twilioConnectSettings,
                    twilioDiagnosticsSettings: twilioDiagnosticsSettings,
                    showPreflight: false,
                    isFetchingTwilioToken: false,
                    roomTokenAssigned: true,
                    videoVisitOpen: this.videoErrorMsg ? false : true
                });
            }

        });
    }

    render() {
        const { videoVisitOpen, videoVisitError, activeVideoId, testVideoOpen, token, roomName, isFetchingTwilioToken, errorMessage,
            twilioUserName, showSpinner, twilioOptionsForTestRoom, twilioConnectSettings, twilioTestRoomSettingsSelected, isConnecting, hasVideoIn,
            showPreflight, preflightTokenInfo, hardwareScanned, hasAudioIn, hasAudioOut, twilioDiagnosticsSettings
        } = this.state;

        const { userName, match, employeeRole, sameDayCareProviderId, epicId, location } = this.props;
        const appointmentDetails = this.getAppointmentDetails();
        var isPOC = true;
        const hasHardwareMissing = (userName !== "e87263@bswhealth.org") && hardwareScanned === true && (!hasAudioIn || !hasAudioOut || !hasVideoIn);
        //Comment out hardware validation check due to impacting providers to launch visit.
        this.videoErrorMsg = ""; // this.getVideoErrorMsg(hasHardwareMissing);
        const isSdcVisit = match.params.sameDayCare ? match.params.sameDayCare.toLowerCase() === "samedaycare" ? true : false : false;
        const istestLobby = this.getIsTestLobby();
        const providerInAnotherRoom = this.getProviderInAnotherRoom(isSdcVisit)

        const displayRoomStatus = !videoVisitOpen || (videoVisitOpen && providerInAnotherRoom);
        const showLeaveRoomBtn = videoVisitOpen && this.props.token && !providerInAnotherRoom && !testVideoOpen && !errorMessage ? true : false;
        const timeToStart = appointmentDetails && appointmentDetails.timeToStart ? true : false;
        const disableEnterRoomBtn = (!appointmentDetails || !timeToStart || !this.props.token /*|| hasHardwareMissing || this.videoErrorMsg !== ""*/) ? true : false;
        this.isOnFlyVisit = location && location.state && location.state.onFlyVisit ? location.state.onFlyVisit : false;

        //Sometimes we are getting report provider "enter button" is disabled.
        if (appointmentDetails && appointmentDetails.csnId && (appointmentDetails.csnId !== this.logEnterRoomBtnForRoomId || this.logEnterRoomBtnForTimeToStart !== timeToStart ||
            this.logEnterRoomBtnForToken !== this.props.token /*|| this.logEnterRoomBtnForHdMissing !== hasHardwareMissing ||*/)) {
            logUI(`UI.VideoVisit.EnterRoom.${!disableEnterRoomBtn ? "Enabled" : "Disabled"}`, new Date(), Tools.getURLPath(), {
                "roomId": appointmentDetails.csnId,
                "timeToStart": timeToStart,
                "isTokenAvail": this.props.token ? true : false,
                "hasHardwareMissing": hasHardwareMissing
            }, appointmentDetails.csnId);
            this.logEnterRoomBtnIsDisabled = disableEnterRoomBtn
            this.logEnterRoomBtnForRoomId = appointmentDetails ? appointmentDetails.csnId : null;
            this.logEnterRoomBtnForTimeToStart = timeToStart;
            this.logEnterRoomBtnForToken = this.props.token;
            //this.logEnterRoomBtnForHdMissing = hasHardwareMissing;
            //this.logEnterRoomBtnForErrorMsg = this.videoErrorMsg;
        }

        const patientName = this.getPatientName();
        const leaveVideoVisitModalText = `<h3>Are you sure you want to leave the appointment in progress ${patientName ? "with " + Formatting.firstNameFirst(patientName) + " " : ""}to enter this room?</h3>`;
        let settings = null;

        const providerid = match.params.providerid;
        const departmentid = match.params.departmentid;
        const showVisitHistory = location && location.pathname && location.pathname.indexOf("/history") > -1 ? true : false;

        try {
            if (twilioTestRoomSettingsSelected && twilioOptionsForTestRoom)
                settings = {
                    twilioConnectSettings: JSON.parse(twilioOptionsForTestRoom), isDynamicSettings: false
                }
        }
        catch (err) {
            settings = null;
        }

        //On Fly Visit join from "Join Virtual Room" button click.
        if (this.isOnFlyVisit && !disableEnterRoomBtn && !this.isOnFlyVisitStarted) {
            this.startVideoVisit(appointmentDetails);
        }

        const getProviderButtons = () => {
            return (
                <>
                    {showLeaveRoomBtn
                        ? <button className="btn btn-primary enter-room-btn" onClick={() => this.leaveVideoVisit(appointmentDetails)}>Leave Room</button>
                        : <button className="btn btn-primary enter-room-btn" disabled={disableEnterRoomBtn} onClick={() => this.startVideoVisit(appointmentDetails)}
                        >Enter Room</button>
                    }
                    <button className="btn btn-primary complete-visit-btn" onClick={this.completeVideoVisit} disabled={!appointmentDetails || !this.props.token}
                    >Complete Visit</button>
                </>
            )
        }

        return (
            <React.Fragment>
                {!videoVisitError || !this.props.token || showVisitHistory
                    ? <div className={`container-fluid body-content ambulatory-care-container ${!providerInAnotherRoom && videoVisitOpen ? "active-video" : ""}`}>
                        {showPreflight && preflightTokenInfo && <Preflight preflightTokenInfo={preflightTokenInfo} callbackOnComplete={this.onPreflightComplete} />}
                        <div className={`row no-gutters`}>
                            <div className={`col-12`}>
                                <VideoVisitToast />
                                {(displayRoomStatus || errorMessage) &&
                                    <>
                                        {(isPOC === true && !this.videoErrorMsg && istestLobby === true && !(videoVisitOpen && this.props.token && !providerInAnotherRoom && testVideoOpen)) &&
                                            <div className="row twilio-test-settings-container">
                                                <div className="col-2">
                                                    <label className="checkbox-container setting-switch">
                                                        <input type="checkbox" name="twilio-settings-input" checked={this.state.twilioTestRoomSettingsSelected} onChange={e => this.setState({ twilioTestRoomSettingsSelected: e.target.checked })} />
                                                        <span className="checkmark" />
                                                        <span className="checkbox-label">Use these settings</span>
                                                    </label>
                                                </div>
                                                <div className="col-10">
                                                    <Text className="twilio-test-settings" name="twilioSettingOptions" placeholder="Twilio Setting Options" id={"twilioSettingOptions"} value={twilioOptionsForTestRoom} onChange={(e) => this.handleSettingsChange(e)} rows="6" autoFocus />
                                                </div>
                                            </div>
                                        }
                                        {!showVisitHistory &&
                                            <AmbulatoryCareRoomStatus
                                                status={this.videoErrorMsg !== "" ? "video error" : "Room Empty"}
                                                appointmentDetails={appointmentDetails} videoErrorMsg={this.videoErrorMsg}
                                                errorMessage={errorMessage}
                                            />
                                        }
                                    </>
                                }
                                {videoVisitOpen && !this.videoErrorMsg &&
                                    <div id="video-meeting-container" className={providerInAnotherRoom ? " thumbnail-video" : ""}>
                                        <Header serverData={serverData} />
                                        {token && roomName && !errorMessage &&
                                            <TwilioVideo
                                                appointmentDetails={appointmentDetails}
                                                twilioToken={token}
                                                twilioRoomName={roomName}
                                                isFetchingTwilioToken={isFetchingTwilioToken}
                                                source={PROVIDER}
                                                twilioUserName={twilioUserName}
                                                onConnected={this.onTwilioRoomConnected}
                                                onTwilioRoomError={this.onTwilioRoomError}
                                                onTwilioEndCall={this.onTwilioEndCall}
                                                twilioSettings={isPOC === true && istestLobby === true ? (twilioTestRoomSettingsSelected ? settings : (twilioConnectSettings ? { twilioConnectSettings, isDynamicSettings: true } : null)) : twilioConnectSettings ? { twilioConnectSettings, isDynamicSettings: true } : null}
                                                localParticipantRole={employeeRole}
                                                twilioDiagnosticsSettings={twilioDiagnosticsSettings}
                                                providerButtons={getProviderButtons()}
                                                kickoutGuest={this.kickoutGuest}
                                            />
                                        }
                                        {providerInAnotherRoom &&
                                            <Link className="video-block-link" to={{ pathname: activeVideoId && activeVideoId.url ? activeVideoId.url : "/providervideovisit" }} aria-label={"Return to Video Visit"}>
                                                <span />
                                            </Link>
                                        }
                                    </div>
                                }

                            </div>
                        </div>
                        {showVisitHistory
                            ? <VisitHistory providerid={providerid} departmentid={departmentid} />
                            : <div className="row">
                                <div className={`col-12 video-button-container`}>
                                    {!istestLobby
                                        ? <React.Fragment>
                                            {getProviderButtons()}
                                            {this.state.showModal &&
                                                <YesNoModal showModal={this.state.showModal} className="complete-visit-modal"
                                                    modalText="<h3>Are you sure you want to end the appointment?</h3>
                                                <p>Ending the visit will conclude the video visit for all parties.</p>"
                                                    modalYesFunction={() => {
                                                        this.closeRoom(appointmentDetails);
                                                        this.props.history.push({
                                                            pathname: '/providersurvey',
                                                            state: {
                                                                isSdcVisit: isSdcVisit,
                                                                csnId: appointmentDetails && appointmentDetails.epicApptCSNId ? appointmentDetails.epicApptCSNId : null,
                                                                twilioUserName: twilioUserName ? twilioUserName : ""
                                                            }
                                                        });
                                                    }} modalNoFunction={() => this.setState({ showModal: false })}
                                                />
                                            }
                                        </React.Fragment>
                                        : <React.Fragment>
                                            {isPOC === true &&
                                                <React.Fragment>
                                                    {videoVisitOpen && this.props.token && !providerInAnotherRoom && testVideoOpen && !this.videoErrorMsg
                                                        ? <button className="btn btn-primary enter-room-btn" onClick={() => this.leaveVideoVisit(appointmentDetails)}>Leave Room</button>
                                                        : <button className="btn btn-primary enter-room-btn"
                                                            disabled={!this.props.token || hasHardwareMissing}
                                                            onClick={() => { this.testVideoVisit(); }}
                                                        >Enter Test Room</button>
                                                    }
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    }
                                </div>
                            </div>}
                    </div>
                    : <ErrorPage heading={"We were unable to begin the video visit."}>
                        <span>Please <button type="button" className="btn text-btn" onClick={() => { this.setState({ videoVisitOpen: false, videoVisitError: false }); }}>try again.</button></span>
                    </ErrorPage>
                }
                {
                    showSpinner === true && !this.videoErrorMsg &&
                    <Spinner fullWidth />
                }
                <YesNoModal
                    showModal={this.state.showLeaveVisitModal}
                    className="leave-room-modal complete-visit-modal"
                    modalText={leaveVideoVisitModalText}
                    modalYesFunction={() => this.onLeaveVisitYesClick(appointmentDetails)}
                    modalNoFunction={this.onLeaveVisitNoClick}
                />
            </React.Fragment >
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userName: state.domain.un,
        epicId: state.domain.eid,
        lanId: state.domain.dlan,
        employeeType: state.domain.et,
        myChartUserId: state.domain.mc,
        email: state.domain.e,
        displayName: state.domain.cu ? state.domain.cu.dn : "BSWH Provider",
        providerExternalName: state.domain.pen ? state.domain.pen : null,
        currentUser: state.domain.cu,
        token: state.domain.t,
        instaDocToken: state.domain.idt,
        roles: state.sso.userDetails ? state.sso.userDetails.Roles : "",
        ambulatoryVideoVisits: state.dashboard.dashboardV2 ? state.dashboard.dashboardV2.ambulatoryVideoVisits : [],
        urgentCareVideoVisits: state.dashboard.dashboardV2 ? state.dashboard.dashboardV2.urgentCareVideoVisits : [],
        loadingProviderAppointments: state.epic.loadingProviderAppointments,
        providerAppointments: state.epic.providerAppointments,
        sameDayCareAppointments: state.epic.sameDayCareAppointments,
        minutesBefore: state.session.serverData.minutesBeforeVideoVisit ? state.session.serverData.minutesBeforeVideoVisit : "480",
        minutesAfter: state.session.serverData.minutesAfterVideoVisit ? state.session.serverData.minutesAfterVideoVisit : "480",
        sameDayCareProviderId: state.session.serverData.sameDayCareProviderId ? state.session.serverData.sameDayCareProviderId : "",
        twilioSettings: state.session.serverData.twilioSettings,
        twilioSettingsForFireFox: state.session.serverData.twilioSettingsForFireFox,
        employeeRole: state.domain.er,
        delayReadingPatientInRoomTimeSecs: state.session.serverData.delayReadingPatientInRoomTimeSecs ? state.session.serverData.delayReadingPatientInRoomTimeSecs : 0,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProviderToken: (participantExternalId, participantName, roomId, callback, apiVersion) => {
            dispatch({ type: types.GET_PROVIDER_JWT, participantExternalId, participantName, roomId, callback, apiVersion });
        },
        enterRoom: () => { dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }); },
        refreshRooms: (data) => dispatch({ type: types.APPOINTMENTS_REFRESH_DATA, data }),
        getShareLinkHistory: (room) => dispatch({ type: types.VIDEO_VISIT_SHARE_LINK_HISTORY, room })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AmbulatoryCareVideoVisit));